export default {
      id: "resend-invite-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#resend-invite",
      toString: function () {
        return this.url;
      }
    }